/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  root: 'root_52fc55e6',
  item: 'item_52fc55e6',
};

export = styles;

loadStyles([{"rawString":".root_52fc55e6{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.item_52fc55e6{-ms-flex-negative:0;flex-shrink:0}"}]);
/* tslint:enable */